// @flow
import { ConfRegActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    confReg: {},
    listaConfReg: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type ConfRegAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { confReg?: {} | null, listaConfReg?: [] | null, loading?: boolean, +value ?: boolean };

const ConfReg = (state: State = INIT_STATE, action: ConfRegAction): any => {
    // console.log(action);
    switch (action.type) {
        case ConfRegActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ConfRegActionTypes.GET_CONF_REG: {
                    return {
                        ...state,
                        confReg: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ConfRegActionTypes.LIST_CONF_REG: {
                    return {
                        ...state,
                        listaConfReg: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ConfRegActionTypes.ADD_CONF_REG: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case ConfRegActionTypes.UPDATE_CONF_REG: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case ConfRegActionTypes.DELETE_CONF_REG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ConfRegActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ConfRegActionTypes.GET_CONF_REG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        confReg: {},
                        loading: false,
                    };
                }
                case ConfRegActionTypes.LIST_CONF_REG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaConfReg: [],
                        loading: false,
                    };
                }
                case ConfRegActionTypes.ADD_CONF_REG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case ConfRegActionTypes.UPDATE_CONF_REG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case ConfRegActionTypes.DELETE_CONF_REG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ConfRegActionTypes.GET_CONF_REG:
            return { ...state, error: false, loading: true };
        case ConfRegActionTypes.LIST_CONF_REG:
            return { ...state, error: false, loading: true };
        case ConfRegActionTypes.ADD_CONF_REG:
            return { ...state, error: false, loadingForm: true };
        case ConfRegActionTypes.UPDATE_CONF_REG:
            return { ...state, error: false, loadingForm: true };
        case ConfRegActionTypes.DELETE_CONF_REG:
            return { ...state, error: false, loading: true };
        case ConfRegActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                confReg: {},
                listaConfReg: [],
                formSubmited: false
            };
        case ConfRegActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default ConfReg;
